import { Link } from 'react-router';
import { buildScopedSearch } from '@hooks';
import DetailDialog from '@/shared/components/DetailDialog/DetailDialog';
import styles from './PlanningItemDetail.module.css';

export default function PlanningItemDetail({ item, onClose, onEdit }) {
  function destination(path, params = {}) {
    const search = buildScopedSearch('', { siteId: item.siteId, assetId: item.assetId }, params);
    return { pathname: path, search: '?' + search };
  }
  return <DetailDialog eyebrow="LOCAL PLANNING PREVIEW" title={item.code}
    subtitle={item.siteLabel + ' / ' + item.assetLabel + ' · ' + item.name} onClose={onClose}>
    <div className={styles.detail}>
      <p className={styles.notice}>This proposed item comes from a local draft. It is not a saved inspection occurrence or a completed inspection.</p>
      <div className={styles.grid}>
        <section className={styles.card}><h3>Proposed work</h3>
          <dl className={styles.metadata}>
            {[['Local draft', item.schedule], ['Owner', item.owner], ['First due', item.due],
            ['Repeat interval', item.frequency + ' months'], ['Subsystem', item.subsystem],
            ['Catalogue link', item.catalogueState]].map(([label, value]) =>
              <div key={label}><dt>{label}</dt><dd>{value || 'Not recorded'}</dd></div>)}
          </dl>
          <p className={styles.note}>Only the proposed first due date is shown. Future recurring occurrences have not been generated.</p>
        </section>
        <section className={styles.card}><h3>Assigned techniques</h3>
          <div className={styles.methods}>{item.techniques.map(method => <span key={method}>{method}</span>)}</div>
          {!item.techniques.length && <p className={styles.notice}>No technique is assigned. Edit the draft before proceeding.</p>}
          {item.unconfirmed.length > 0 && <p className={styles.note}>Not confirmed as eligible by the current catalogue: {item.unconfirmed.join(' · ')}. Review the assignment; it has not been removed.</p>}
          <h3 className={styles.subheading}>Notes</h3><p className={styles.notes}>{item.notes || 'No notes recorded.'}</p>
        </section>
        <section className={styles.card}><h3>Report evidence</h3>
          <p>A report must be linked to the eventual inspected item. Report assignment and completion are not connected yet.</p>
          <p className={styles.note}>Existing asset reports are reference material; opening one does not attach it to this item.</p>
        </section>
        <section className={styles.card}><h3>Anomaly observations</h3>
          <p>An inspected item may have no anomalies or several observations. Observation links are not connected yet.</p>
          <p className={styles.note}>Existing asset anomalies are not automatically observations from this proposed work.</p>
        </section>
      </div>
      <div className={styles.actions}>
        <button type="button" onClick={() => onEdit(item.snapshot)}>Edit source draft</button>
        {item.catalogueState === 'Available' && <Link target="_blank" rel="noopener noreferrer"
          to={destination('/iod', { 'components.selected': item.key })}>Open IOD detail ↗</Link>}
        <Link target="_blank" rel="noopener noreferrer" to={destination('/report-browser')}>Browse asset reports ↗</Link>
        <Link target="_blank" rel="noopener noreferrer" to={destination('/anomaly-suite', { anomalyView: 'register' })}>Browse asset anomalies ↗</Link>
      </div>
      <p className={styles.note}>Reference links open in a new tab so this page retains its local drafts.</p>
    </div>
  </DetailDialog>;
}